import { Placement } from "react-aria";

export const handlePopoverRotation = (placement: Placement | null) => {
  switch (placement) {
    case "top":
      return "rotate-180";
    case "bottom":
      return "rotate-0 ";
    case "left":
      return "rotate-90 !top-[42%] !left-[97.8%]";
    case "right":
      return "!top-[42%] !right-[97.6%] -rotate-90";
    case "bottom right":
      return "rotate-0  !left-[85%]";
    default:
      return "";
  }
};
